import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@design-system-coopeuch/web';
import { casoBordeActions } from '../../../../application/actions/casoBordes';
import { properties } from '../../../../utils/properties';
import TagManagerUtils from '../../../../utils/TagManagerUtils';
import { useDevice } from '../../../../hooks';
import errorUsuario from '../../../assets/img/icon/User-Error.svg';
import errorUsuarioMobile from '../../../assets/img/icon/User-Error-Mobile.svg';
import { WrapperCasosBordes } from './styles';

const CasosBordeTemplateConexion = () => {
  const [paso] = useState(localStorage.getItem('paso') || '/');

  const { isMobile } = useDevice();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(casoBordeActions.casoBordeEstado(true));
    TagManagerUtils.triggerEventMetodo(
      "trigger_event",
      "",
      "/verificacion",
      "Error",
      "No cumple las condiciones",
    );
    localStorage.removeItem('paso');
  },[])

  const volverAHome = () =>{
    window.location.href = properties.urlCoopeuch;
    TagManagerUtils.triggerEventMetodo("trigger_event", 'No Socio', "/verificacion", "Click", "Volver a coopeuch.cl");
  }

  const redirect = () => {
    window.location.replace(paso);
  }

  return (
    <WrapperCasosBordes>
      <h1>{properties.casosBordes.CasoBorde.titulo}</h1>
      <img src={!isMobile ? errorUsuario : errorUsuarioMobile} alt="error usuario" />
      <h2>{properties.casosBordes.ErrorServidor.subtitulo}</h2>
      <p>{properties.casosBordes.ErrorServidor.bajada}</p>
      <div className="reintentar">
        <Button variant='outline' onClick={redirect}>Reintentar</Button>
      </div>
      <div className="volver">
        <Button variant='text' onClick={volverAHome} disabled={false}>{properties.casosBordes.CasoBorde.textoBotonDos}</Button>
      </div>
    </WrapperCasosBordes>
  )
}

export default CasosBordeTemplateConexion;